import { motion } from "framer-motion";
import { Briefcase, Check, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { scrollToId } from "./Nav";

export const Soho = () => {
  const { t } = useLang();
  const s = t.soho;

  return (
    <section id="soho" className="py-20 md:py-28 border-t border-white/10" data-testid="soho-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="border border-white/10 bg-[#111111] p-8 md:p-14 grid lg:grid-cols-2 gap-10 lg:items-center"
        >
          <div>
            <p className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#FF7900] mb-5">
              <Briefcase className="w-4 h-4" /> {s.overline}
            </p>
            <h2 className="font-display text-3xl md:text-4xl font-medium tracking-tight mb-4">{s.title}</h2>
            <p className="text-white/60 text-sm md:text-base mb-8 max-w-lg">{s.text}</p>
            <button
              onClick={() => scrollToId("contact")}
              data-testid="soho-cta"
              className="inline-flex items-center gap-2 bg-[#FF7900] hover:bg-white hover:text-black text-white text-sm font-semibold px-6 py-3 rounded-full transition-colors duration-300"
            >
              {s.cta}
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>
          <ul className="flex flex-col gap-4">
            {s.points.map((p) => (
              <li key={p} className="flex items-start gap-3 border border-white/10 bg-[#0d0d0d] px-5 py-4 text-sm text-white/80">
                <Check className="w-4 h-4 text-[#FF7900] shrink-0 mt-0.5" />
                {p}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};
